/* eslint-disable react/prop-types */
import {useContext, useMemo} from 'react'

import Context from '@s-ui/react-context'
import Helmet from '@s-ui/react-head'
import Layout from '@adv-mt/mt-layout-basic'
import ListLatestModels, {listLatestModelsSizes} from '@adv-mt/mt-list-latest-models'
import SectionBasic, {sectionBasicMargins} from '@adv-mt/mt-section-basic'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../components/LinkFactory/index.js'
import {MakeModelSelector} from './components/MakeModelSelector.js'
import {getInitialProps} from './getInitialProps.js'
import {BASE_CLASS} from './settings.js'

const MakesDistributor = ({carousels = [], h1 = '', helmet, loadThirdParties, pageName, serverErrors = []}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {DISTRIBUTOR_PAGE_CONFIG: pageConfig} = config.get('page')
  const hasErrors = Boolean(serverErrors.length)

  const carouselsSections = useMemo(
    () =>
      carousels.map(({title, items}) => {
        return (
          <SectionBasic margin={sectionBasicMargins.xxl} key={title} title={title} titleSize={titleBasicSizes.s}>
            <ListLatestModels models={items} size={listLatestModelsSizes.LARGE} />
          </SectionBasic>
        )
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [carousels]
  )

  if (hasErrors) return <></>

  const h2 = i18n.t(`DISTRIBUTOR.${pageConfig[pageName].literalPrefix}.H2`)

  return (
    <Layout.Basic isPaddingless linkFactory={LinkFactory}>
      <Helmet {...helmet} />
      <div className={BASE_CLASS}>
        <SectionBasic margin={sectionBasicMargins.xxl}>
          <TitleBasic size={titleBasicSizes.m} title={h1} />
        </SectionBasic>

        <SectionBasic margin={sectionBasicMargins.xxl}>
          <div className={`${BASE_CLASS}FilterWrapper`}>
            <div className={`${BASE_CLASS}FilterTitle`}>
              <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.s} title={h2} />
            </div>
            <MakeModelSelector pageName={pageName} />
          </div>
        </SectionBasic>
        {carouselsSections}
      </div>
      {loadThirdParties && <TrackingPageView pageName={pageName} />}
    </Layout.Basic>
  )
}

MakesDistributor.displayName = 'MakesDistributor'

MakesDistributor.propTypes = {}

// It keeps page mounted in order to avoid flickering when user filters
MakesDistributor.keepMounted = true

MakesDistributor.getInitialProps = getInitialProps

export default MakesDistributor
